export enum ShipmentSearchFilter {
  CLIENT = 'CLIENT',
  ID = 'ID',
  SCAC = 'SCAC',
  SERVICE = 'SERVICE',
  MODE = 'MODE',
  EQUIPMENT_TYPE = 'EQUIPMENT_TYPE',
  HEALTH = 'HEALTH',
  STATUS = 'STATUS',
  FINANCIAL_STATUS = 'FINANCIAL_STATUS',
  ORIGIN = 'ORIGIN',
  DESTINATION = 'DESTINATION',
  ORIGIN_LOCATION_GROUPS = 'ORIGIN_LOCATION_GROUPS',
  DESTINATION_LOCATION_GROUPS = 'DESTINATION_LOCATION_GROUPS',
  EXPECTED_PICKUP = 'EXPECTED_PICKUP',
  ACTUAL_PICKUP_ARRIVAL = 'ACTUAL_PICKUP_ARRIVAL',
  ACTUAL_PICKUP_DEPARTURE = 'ACTUAL_PICKUP_DEPARTURE',
  SCHEDULED_PICKUP = 'SCHEDULED_PICKUP',
  REQUESTED_PICKUP = 'REQUESTED_PICKUP',
  PICKUP_APPOINTMENT_REQUIRED = 'PICKUP_APPOINTMENT_REQUIRED',
  EXPECTED_DELIVERY = 'EXPECTED_DELIVERY',
  ACTUAL_DELIVERY_ARRIVAL = 'ACTUAL_DELIVERY_ARRIVAL',
  ACTUAL_DELIVERY_DEPARTURE = 'ACTUAL_DELIVERY_DEPARTURE',
  SCHEDULED_DELIVERY = 'SCHEDULED_DELIVERY',
  REQUESTED_DELIVERY = 'REQUESTED_DELIVERY',
  DELIVERY_APPOINTMENT_REQUIRED = 'DELIVERY_APPOINTMENT_REQUIRED',
  CREATED_DATE = 'CREATED_DATE',
  GL_CODE = 'GL_CODE',
  TAG = 'TAG',
  MULTISTOP = 'MULTISTOP',
  PRODUCT_NUMBER = 'PRODUCT_NUMBER',
  HAS_PARCEL_PICKUP_APPOINTMENT = 'HAS_PARCEL_PICKUP_APPOINTMENT',
  HOT = 'HOT',
  HAZMAT = 'HAZMAT',
  PAYABLE = 'PAYABLE',
  DIRECTION = 'DIRECTION',
  BILLING_TERMS = 'BILLING_TERMS',
  FREIGHT_ALLOWANCE_ENABLED = 'FREIGHT_ALLOWANCE_ENABLED',
  ASSIGNED_USERS = 'ASSIGNED_USERS',
  CANCELLATION_REASON = 'CANCELLATION_REASON',
  REQUESTED_MODE = 'REQUESTED_MODE',
  FREIGHT_ALLOWANCE = 'FREIGHT_ALLOWANCE',
  COST_ESTIMATE = 'COST_ESTIMATE',
  WEIGHT = 'WEIGHT',
  HANDLING_UNIT = 'HANDLING_UNIT',
  SOURCE = 'SOURCE',
  SWC = 'SWC',
  CUSTOMER_ROUTED = 'CUSTOMER_ROUTED',
  MANIFEST_NUMBER = 'MANIFEST_NUMBER',
  MANIFEST_STATUS = 'MANIFEST_STATUS',
}
